var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tms-dashboard wp-dashboard-route" }, [
    _c("div", { staticClass: "content-body" }, [
      _c("div", { staticClass: "nav-bar-container" }, [
        _c("div", { staticClass: "nav-bar clearfix" }, [
          _c("div", { staticClass: "welcome" }, [
            _c("span", { staticClass: "summary-hello" }, [
              _vm._v(_vm._s(_vm.$t("hello"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "summary-name" }, [
              _vm._v(
                _vm._s(
                  (_vm.currentUserContact || {}).name || _vm.currentUser.name
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "summary-items" }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tenant-dashboard__wrapper" },
        [_c("WorkPermitTable", { key: _vm.componentKey })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }